import * as React from "react";
import {
  Button,
  createStyles,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Theme,
  withStyles,
} from "@material-ui/core";
import { API } from "aws-amplify";
import { Alert } from "@material-ui/lab";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import ErrorResponse from "../../../order/components/create_order/ErrorResponse";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

interface IShipmentStatusState {
  orderType: string;
  profileId: string;
  personId: string;
  purchaseId: string;
  orderId: string;
  orderDate: string;
  shipmentStatus: string;
  lastSeenCarrierUpdate: string;
  estimatedArrival: string;
  shipDate: string;
  latestEventDate: string;
  formSubmitted: boolean;
  resultSuccessful: boolean;
  message: string;
  errorText: string;
}

class ShipmentStatusSection extends React.Component<any, IShipmentStatusState> {
  private readonly PROFILE_ID_REGEX =
    "^amzn[0-9]*\\.pharmacy\\.profile\\.id\\.[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";

  constructor(props: any) {
    super(props);
    this.state = {
      orderType: "BULK",
      profileId: "",
      personId: "",
      purchaseId: "",
      orderId: "",
      orderDate: "",
      shipmentStatus: "",
      lastSeenCarrierUpdate: "",
      estimatedArrival: "",
      shipDate: "",
      latestEventDate: "",
      formSubmitted: false,
      resultSuccessful: false,
      message: "",
      errorText: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public render() {
    const isPackets = this.state.orderType === "PACKETS";

    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          <Alert severity="info">
            <p>Make sure your order is in 'Closed' status and shipment is in 'Shipped' status</p>
          </Alert>
          <Grid item xs>
            <FormControl variant="outlined" style={{ width: 508 }}>
              <InputLabel>Order Type</InputLabel>
              <Select
                value={this.state.orderType}
                onChange={(e) => this.setState({
                  orderType: e.target.value as string,
                  resultSuccessful: false,
                  errorText: "",
                })}
                label="Order Type"
              >
                <MenuItem value="BULK">Bulk</MenuItem>
                <MenuItem value="PACKETS">Packets</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {!isPackets && (
            <Grid item xs>
              <TextField
                style={{ width: 508 }}
                label="Profile Id (Required)"
                variant="outlined"
                value={this.state.profileId}
                helperText={this.state.errorText}
                onChange={(e) => {
                  const val = e.target.value;
                  this.setState({ profileId: val, resultSuccessful: false });
                  this.setState({
                    errorText: val && !val.match(this.PROFILE_ID_REGEX) ? "Invalid Profile Id" : "",
                  });
                }}
              />
            </Grid>
          )}
          {isPackets && (
            <Grid item xs>
              <TextField
                style={{ width: 508 }}
                label="Person Id (Required for Packets)"
                variant="outlined"
                value={this.state.personId}
                onChange={(e) => this.setState({ personId: e.target.value, resultSuccessful: false })}
              />
            </Grid>
          )}
          <Grid item xs>
            <TextField
              style={{ width: 508 }}
              label="Purchase Id (Required)"
              variant="outlined"
              value={this.state.purchaseId}
              onChange={(e) => this.setState({ purchaseId: e.target.value })}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 508 }}
              label="Order Id (Required)"
              variant="outlined"
              value={this.state.orderId}
              onChange={(e) => this.setState({ orderId: e.target.value })}
            />
          </Grid>
          <Grid item xs>
            <p style={{ margin: 0, fontSize: "0.85rem", color: "gray" }}>initialSigningTime from PCELegacy in Grass</p>
            <TextField
              style={{ width: 508 }}
              label="Order Date (Required, e.g. 1777683139.222)"
              variant="outlined"
              value={this.state.orderDate}
              onChange={(e) => this.setState({ orderDate: e.target.value })}
            />
          </Grid>
          <Grid item xs>
            <FormControl variant="outlined" style={{ width: 508 }}>
              <InputLabel>Shipment Status (Required)</InputLabel>
              <Select
                value={this.state.shipmentStatus}
                onChange={(e) => this.setState({ shipmentStatus: e.target.value as string })}
                label="Shipment Status (Required)"
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Generated">Generated</MenuItem>
                <MenuItem value="Exception">Exception</MenuItem>
                <MenuItem value="InTransit">InTransit</MenuItem>
                <MenuItem value="OutForDelivery">OutForDelivery</MenuItem>
                <MenuItem value="Delivered">Delivered</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 508 }}
              label="Last Seen Carrier Update (Optional, e.g. 6)"
              variant="outlined"
              value={this.state.lastSeenCarrierUpdate}
              onChange={(e) => this.setState({ lastSeenCarrierUpdate: e.target.value })}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 508 }}
              label="Estimated Arrival (Optional, e.g. 1754463600000)"
              variant="outlined"
              value={this.state.estimatedArrival}
              onChange={(e) => this.setState({ estimatedArrival: e.target.value })}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 508 }}
              label="Ship Date (Optional, e.g. 1754318968000)"
              variant="outlined"
              value={this.state.shipDate}
              onChange={(e) => this.setState({ shipDate: e.target.value })}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 508 }}
              label="Latest Event Date (Optional, e.g. 2025-08-05T11:06:00.000-05:00)"
              variant="outlined"
              value={this.state.latestEventDate}
              onChange={(e) => this.setState({ latestEventDate: e.target.value })}
            />
          </Grid>
          <Grid item xs>
            <Button
              variant="outlined"
              color="default"
              onClick={this.handleSubmit}
            >
              Update Shipment Status
            </Button>
          </Grid>
          <Grid item xs={12}>
            {this.state.formSubmitted && <LoadingSpinner />}
            {this.state.resultSuccessful && (
              <div style={{ color: "green", textAlign: "center" }}>
                Shipment status updated successfully!
              </div>
            )}
          </Grid>
          {this.state.message && (
            <ErrorResponse
              message={this.state.message}
              dialogTitle={"Update Shipment Status Exception"}
            />
          )}
        </Grid>
      </Grid>
    );
  }

  private handleSubmit() {
    const isPackets = this.state.orderType === "PACKETS";

    if (isPackets) {
      if (!this.state.personId) {
        alert("Please enter the Person Id");
        return;
      }
    } else {
      if (!this.state.profileId || !this.state.profileId.match(this.PROFILE_ID_REGEX)) {
        alert("Please enter a valid Profile Id");
        return;
      }
    }
    if (!this.state.purchaseId) {
      alert("Please enter the Purchase Id");
      return;
    }
    if (!this.state.orderId) {
      alert("Please enter the Order Id");
      return;
    }
    if (!this.state.orderDate) {
      alert("Please enter the Order Date");
      return;
    }
    if (!this.state.shipmentStatus) {
      alert("Please enter the Shipment Status");
      return;
    }

    this.setState({ formSubmitted: true, resultSuccessful: false, message: "" });

    const apiName = "ApaqPortalAPI";
    const path = "/order/update-shipment-status";
    const body: any = {
      purchaseId: this.state.purchaseId,
      orderId: this.state.orderId,
      orderDate: this.state.orderDate,
      shipmentStatus: this.state.shipmentStatus,
      orderType: this.state.orderType,
    };
    if (isPackets) {
      body.personId = this.state.personId;
    } else {
      body.profileId = this.state.profileId;
    }
    if (this.state.lastSeenCarrierUpdate) {
      body.lastSeenCarrierUpdate = parseInt(this.state.lastSeenCarrierUpdate, 10);
    }
    if (this.state.estimatedArrival) {
      body.estimatedArrival = parseInt(this.state.estimatedArrival, 10);
    }
    if (this.state.shipDate) {
      body.shipDate = parseInt(this.state.shipDate, 10);
    }
    if (this.state.latestEventDate) {
      body.latestEventDate = this.state.latestEventDate;
    }

    const config = {
      body,
      headers: {},
    };

    API.post(apiName, path, config)
      .then(() => {
        this.setState({ resultSuccessful: true, formSubmitted: false });
      })
      .catch((error) => {
        this.setState({
          formSubmitted: false,
          message: error.response?.data?.message || error.message,
        });
      });
  }
}

export default withStyles(styles)(ShipmentStatusSection);
